export default {
  methods: {
    parametroDoEsquema(esquemas, tipo, chave) {
      const parametros = esquemas?.[tipo]?.parametros;
      if (!Array.isArray(parametros)) return null;
      return parametros.find((item) => item && item.chave === chave) || null;
    },
    opcoesDominio(parametro) {
      if (!parametro || !Array.isArray(parametro.dominio)) return [];
      return parametro.dominio.map((entrada) => ({
        text: entrada.valor,
        value: entrada.valor,
        tiposPermitidos: entrada.tiposPermitidos || entrada.tipos_permitidos || null,
        exigeParametro: entrada.exigeParametro || entrada.exige_parametro || null,
        alteraTipoSaida: !!(entrada.alteraTipoSaida || entrada.altera_tipo_saida)
      }));
    },
    primeiroValor(parametro) {
      const opcoes = this.opcoesDominio(parametro);
      return opcoes.length ? opcoes[0].value : null;
    },
    opcoesPorTipoDado(parametro, tipoDado) {
      return this.opcoesDominio(parametro).filter((opcao) => {
        if (!opcao.tiposPermitidos || !opcao.tiposPermitidos.length) return true;
        return opcao.tiposPermitidos.includes(tipoDado);
      });
    },
    varianteMascara(parametro, valor) {
      return this.opcoesDominio(parametro).find((opcao) => opcao.value === valor) || null;
    },
    tiposDeTemplate(templates, tipoPadrao = 'STANDARD') {
      const lista = Array.isArray(templates) ? templates : [];
      const temStandard = lista.some((template) => {
        const nome = String(template?.nome || '').toUpperCase();
        return nome === 'STANDARD' || nome.includes('STANDARD');
      });
      const temOutro = lista.some((template) => {
        const nome = String(template?.nome || '').toUpperCase();
        return nome && !nome.includes('STANDARD');
      });

      const tipos = [];
      if (temStandard || tipoPadrao === 'STANDARD') {
        tipos.push({ text: 'Standard', value: 'STANDARD' });
      }
      if (temOutro) {
        tipos.push({ text: 'Custom', value: 'CUSTOM' });
      }
      return tipos.length ? tipos : [{ text: 'Standard', value: tipoPadrao || 'STANDARD' }];
    }
  }
};
